export const ResetStateActionType = 'signOut/fulfilled';
